<div #imageWrapper class="wrapper-image-large">
  <div class="gallery-content">
    @defer (when currentImage()) {
      <div class="image-large">
        <div class="content-top">
          <ng-content select="[top]"></ng-content>
        </div>
        @if (!isMobile()) {
          <ui-image-gallery-magnifier
            [overlayReferenceElement]="overlayReferenceElement()"
            [src]="currentImage().extralarge ?? currentImage().large"
            [alt]="currentImage().small"
            [zoomImageSrc]="currentImage().extralarge ?? currentImage().large"
          ></ui-image-gallery-magnifier>
        } @else {
          <img
            class="image-mobile"
            width="336"
            height="336"
            priority
            [ngSrc]="currentImage().extralarge ?? currentImage().large"
            [alt]="currentImage().large">
        }
        @if (!isMobile()) {
          <p class="info-text">Für größere Ansicht Maus über das Bild ziehen</p>
        }
      </div>
    }

    @if (images().length > 1) {
      <div class="image-list">
        @for (image of images(); track image) {
          <div class="image-thumbnail" [class.image-active]="image === currentImage()" (mouseover)="changeImage(image)" (tap)="changeImage(image)">
            <img width="38" height="38" [ngSrc]="image.small" [alt]="image.large">
          </div>
        }
      </div>
    }
  </div>
</div>
